export default `varying vec2 vUv;

vec2 hash2( vec2 p )
{
	
	
	
    
	return fract(sin(vec2(dot(p,vec2(127.1,311.7)),dot(p,vec2(269.5,183.3))))*43758.5453);
}

float hash1( float n )
{
    return fract(sin(n)*43758.5453);
}

vec4 voronoiSmooth( in vec2 x, in float time, in vec2 rep, float w )
{
    vec2 n = floor( x );
    vec2 f = fract( x );

	vec4 m = vec4( 8.0, 0.0, 0.0, 0.0 );
    for( int j=-2; j<=2; j++ )
    for( int i=-2; i<=2; i++ )
    {
        vec2 g = vec2( float(i),float(j) );
        vec2 p = mod(n + g, rep);
        vec2 o = hash2( p );
		
		#ifdef ANIMATE
        o = 0.5 + 0.5*sin( time + 6.2831*o );
        #endif

        
		float d = length(g - f + o);
		
        
		vec3 col = 0.5 + 0.5*sin( hash1(dot(p,vec2(7.0,113.0)))*2.5 + 3.5 + vec3(2.0,3.0,0.0));
        
        col = col*col;
        
        
		float h = smoothstep( -1.0, 1.0, (m.x-d)/w );
	    m.x   = mix( m.x,     d, h ) - h*(1.0-h)*w/(1.0+3.0*w); 
		m.yzw = mix( m.yzw, col, h ) - h*(1.0-h)*w/(1.0+3.0*w); 
    }
	
	return m;
}

vec3 voronoi( in vec2 x, in float time, in vec2 rep )
{
    vec2 ip = floor(x);
    vec2 fp = fract(x);

    
    
    
	vec2 mg, mr;

    float md = 8.0;
    for( int j=-1; j<=1; j++ )
    for( int i=-1; i<=1; i++ )
    {
        vec2 g = vec2(float(i),float(j));
		vec2 o = hash2( mod(ip + g, rep) );
		#ifdef ANIMATE
        o = 0.5 + 0.5*sin( time + 6.2831*o );
        #endif	
        vec2 r = g + o - fp;
        float d = dot(r,r);

        if( d<md )
        {
            md = d;
            mr = r;
            mg = g;
        }
    }

    
    
    
    md = 8.0;
    for( int j=-2; j<=2; j++ )
    for( int i=-2; i<=2; i++ )
    {
        vec2 g = mg + vec2(float(i),float(j));
		vec2 o = hash2( mod(ip + g, rep) );
		#ifdef ANIMATE
        o = 0.5 + 0.5*sin( time + 6.2831*o );
        #endif	
        vec2 r = g + o - fp;

        if( dot(mr-r,mr-r)>0.00001 )
        md = min( md, dot( 0.5*(mr+r), normalize(r-mr) ) );
    }

    return vec3( md, mr );
}

void main()
{
    
    float noiseR = voronoi(vUv * 6., 123.456, vec2(6.)).x;
    
    float noiseG = voronoiSmooth(vUv * 6., 103.456, vec2(6.), 0.3).x;

    gl_FragColor = vec4(noiseR, noiseG, 0., 1.0);
}`